import React from 'react';
import {
  Box,
  Typography,
  Stack,
  TextField,
  Tooltip,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

export default function MetadataPanel({ metadata, onChange }) {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        Document Metadata
      </Typography>
      <Stack spacing={2}>
        <TextField
          label="Title"
          fullWidth
          value={metadata.title}
          onChange={(e) => onChange({ ...metadata, title: e.target.value })}
        />
        <Tooltip title="Offset between book-level and PDF-level page numbers. Formula: Book Page = PDF Page + Offset. For cover as page 0, use -1.">
          <TextField
            label="Page Offset"
            type="number"
            fullWidth
            value={metadata.page_offset}
            onChange={(e) => onChange({ ...metadata, page_offset: parseInt(e.target.value) || 0 })}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small">
                    <InfoIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText={`Example: PDF page 1 = Book page ${1 + metadata.page_offset}`}
          />
        </Tooltip>
      </Stack>
    </Box>
  );
}
